var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchInput(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2526",
    "data-name": "Group 2526",
    transform: "translate(-20627 -4648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2562",
    "data-name": "Rectangle 2562",
    width: 38,
    height: 38,
    rx: 10,
    transform: "translate(20627 4648)",
    fill: "#9589e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M21.723,20.615,15.411,14.3A8.527,8.527,0,0,0,17.4,8.816a8.7,8.7,0,0,0-17.4,0A8.711,8.711,0,0,0,14.1,15.57L20.433,21.9a.912.912,0,1,0,1.289-1.289ZM1.849,8.821a6.849,6.849,0,0,1,13.7,0,6.849,6.849,0,0,1-13.7,0Z",
    transform: "translate(20635 4655.8)",
    fill: "#212121"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInput);
export default __webpack_public_path__ + "static/media/search-input.ad3b3349dc4aeab5eea01c7f367d2c84.svg";
export { ForwardRef as ReactComponent };